import "./ProductTestimonial.css";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import button from "../assetsproduct/button.png";
import symbol from "../assetsproduct/symbol.png";
import f1 from "../assetsproduct/pic1.png";
import f2 from "../assetsproduct/pic2.png";
import f3 from "../assetsproduct/pic3.png";
import f4 from "../assetsproduct/pic4.png";
const ProductTestimonial = () => {
  const data = [
    {
      id: 1,
      image: f1,
      name: "Rajesh Kumar ",
      position: "– Bengaluru, India",
      feedback:
        "Working with this product development company was seamless. Their MVP consulting services helped us validate our idea quickly, and the final product exceeded our expectations in every way.",
    },
    {
      id: 2,
      image: f2,
      name: "Tanvi Mehta",
      position: "– Mumbai, India",
      feedback:
        "We came in with a rough idea and a lot of questions. The team helped us shape the product step by step, keeping things practical and aligned with our business goals.",
    },
    {
      id: 3,
      image: f3,
      name: "Emily Thompson",
      position: "– New York, USA",
      feedback:
        "I was impressed with their structured approach and attention to detail. The product development company delivered exactly what we needed, and the MVP consulting made the process risk-free.",
    },
    {
      id: 4,
      image: f4,
      name: "Lucas Martin",
      position: "– London, UK",
      feedback:
        "I was impressed with their structured approach and attention to detail. The product development company delivered exactly what we needed, and the MVP consulting made the process risk-free.",
    },
  ];
  const settings = {
    dots: false,
    arrows: true,
    autoplay: true,
    infinite: true,
    speed: 900,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplaySpeed: 3000,
    cssEase: "ease-in-out",
    nextArrow: <img src={button} alt="Next" className="nextArrow" />,
    prevArrow: <img src={button} alt="Previous" className="prevArrow" />,
    responsive: [
      {
        breakpoint: 1150,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: true,
          dots: false,
        },
      },
      {
        breakpoint: 700,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 1,
        },
      },
    ],
  };
  return (
    <div id="product-testimonial" className="machinemainclass">
      <h2 className="heading">Clients Who Trust Our Work</h2>
      <Slider {...settings}>
        {data.map((item) => {
          return (
            <div className="fwrapper" key={item.id}>
              <div className="fbox">
                <div className="symbolbox">
                  <img src={symbol} alt="" className="symbolimage" />
                </div>
                <div className="fcontent">
                  <p>{item.feedback}</p>
                  <div className="personinfo">
                    <h3>{item.name}</h3>
                    <h4>{item.position}</h4>
                  </div>
                </div>
                <div className="profilebox">
                  <img src={item.image} alt="" className="profileimage" />
                </div>
              </div>
            </div>
          );
        })}
      </Slider>
    </div>
  );
};

export default ProductTestimonial;
